const _version = "2.8.2"
function version() {
    return _version;
}
export default version
